// extracted by mini-css-extract-plugin
export var boxItems = "_62-1";
export var boxItemsLg = "_62-2";
export var button = "_62-7";
export var buttonHoverless = "_62-9";
export var buttonLg = "_62-8";
export var filterGroupBox = "_62-0";
export var icon = "_62-3";
export var iconSecondary = "_62-6";
export var iconWrapper = "_62-4";
export var iconWrapperLg = "_62-5";
export var truncatedLabel = "_62-a";